export default {"src":"/_next/static/media/navigate.b75500c3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};